module.exports = __webpack_public_path__ + "static/media/closeBlackButton.5c468c88.svg";